import { globalInit } from '@/js/global';
import register from '@/js/components';
import { cl } from '@/js/utils';
import { barbaInit } from '@/js/barba';
import { default as initAnimations } from '@/js/animations';
import select from "dom-select";

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(() => {
    console.log('[vite] HMR');
  });
}

(function (doc) {
  register();
  barbaInit();
  globalInit();
  initAnimations();

  doc.addEventListener('DOMContentLoaded', () => {
    doc.fonts.ready.then(() => {
      cl(document.documentElement).remove('to-load');
    });
  });

  if (window.sentryOn) {
    import('@/js/utils/sentry').then((module) => {
      if (!module) return;
      const { default: SentryInit } = module;
      SentryInit({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        maxBreadcrumbs: 50,
        tracesSampleRate: 1.0,
        release: 'frontend'
      });
    });
  }
})(document);
